"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formConfigModifier = require("./utils/formConfigModifier");

var _set = require("lodash/set");

var _set2 = _interopRequireDefault(_set);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _actions = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _actions2 = require("egov-ui-kit/redux/form/actions");

var _actions3 = require("egov-ui-kit/redux/common/actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "ownershipType",
  fields: {
    ownerShipCategoryDropDown: {
      id: "ownerShipCategoryDropDown",
      jsonPath: "Properties[0].ownershipCategory",
      required: true,
      localePrefix: true,
      labelsFromLocalisation: true,
      type: "AutocompleteDropdown",
      floatingLabelText: "Ownership Category",
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      fullWidth: true,
      hintText: "PT_COMMONS_SELECT_PLACEHOLDER",
      numcols: 6,
      gridDefination: {
        xs: 12,
        sm: 6
      },

      updateDependentFields: function updateDependentFields(_ref) {
        var formKey = _ref.formKey,
            field = _ref.field,
            dispatch = _ref.dispatch,
            state = _ref.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].ownershipCategory", field.value));
      }
    },

    personLiableToPayTax: {
      id: "personLiableToPayTax",
      jsonPath: "Properties[0].personLiableTax",
      type: "textfield",
      floatingLabelText: "Person Liable To PayTax",
      hintText: "Person Liable To PayTax",
      required: false,
      disabled: false,
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      errorMessage: "PT_NAME_ERROR_MESSAGE",
      updateDependentFields: function updateDependentFields(_ref2) {
        var formKey = _ref2.formKey,
            field = _ref2.field,
            dispatch = _ref2.dispatch,
            state = _ref2.state;

        if (field.value) dispatch((0, _actions.prepareFinalObject)("Properties[0].personLiableTax", field.value));
      }
    }
  },
  afterInitForm: function afterInitForm(action, store, dispatch) {
    var ownerShipTypeData = [{ name: "State Govt Premises", code: "State Govt Premises", value: "State Govt Premises", label: "State Govt Premises" }, { name: "Central Govt Premises", code: "Central Govt Premises", value: "Central Govt Premises", label: "Central Govt Premises" }, { name: "Statutory Bodies", code: "Statutory Bodies", value: "Statutory Bodies", label: "Statutory Bodies" }, { name: "Thika Premises", code: "Thika Premises", value: "Thika Premises", label: "Thika Premises" }, { name: "Bustee Premises", code: "Bustee Premises", value: "Bustee Premises", label: "Bustee Premises" }, { name: "Khasmahal Property", code: "Khasmahal Property", value: "Khasmahal Property", label: "Khasmahal Property" }, { name: "Private Property", code: "Private Property", value: "Private Property", label: "Private Property" }];

    dispatch((0, _actions2.setFieldProperty)("ownershipType", "ownerShipCategoryDropDown", "dropDownData", ownerShipTypeData));

    var getParameterByName = function getParameterByName(name) {
      var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.href;

      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    };

    var urlParams = getParameterByName("isInspection");

    if (urlParams == "yes") {
      var state = store.getState();
      var data = (0, _get2.default)(state.screenConfiguration.preparedFinalObject, "Properties[0]");
      if (data) {
        var ownerType = data;

        dispatch((0, _actions2.setFieldProperty)("ownershipType", "ownerShipCategoryDropDown", "value", data.ownershipCategory ? data.ownershipCategory : ""));
        dispatch((0, _actions2.setFieldProperty)("ownershipType", "personLiableToPayTax", "value", ownerType.personLiableTax ? ownerType.personLiableTax : ""));

        dispatch((0, _actions.prepareFinalObject)("Properties[0].ownershipCategory", data.ownershipCategory ? data.ownershipCategory : ""));
        dispatch((0, _actions.prepareFinalObject)("Properties[0].personLiableTax", ownerType.personLiableTax ? ownerType.personLiableTax : ""));
      }
    }
    // dispatch(setFieldProperty("ownershipType", "numberOfOwners", "dropDownData", numberOfOwnersData));
    //dispatch(setFieldProperty("ownershipType", "premisesType", "dropDownData", premisesTypeData));
  },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};

exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayForInspection/ownershipType.js
// module id = 1884
// module chunks = 1137